import { useEffect } from 'react';

type ComponentType = 'Section' | 'Video' | 'Accordion';

interface ComponentEntry {
    componentInfo: {
        componentID: string;
    };
    category: {
        primaryCategory: string | null;
        componentType: ComponentType | null;
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const digitalData = (): any => (window as any).du_digitalData;

function getComponentArray(): ComponentEntry[] {
    const data = digitalData();
    if (!data) return [];
    if (!data.component) {
        data.component = [];
    }
    return data.component as ComponentEntry[];
}

export function useComponentTracking(
    componentID: string,
    isVisible: boolean,
    primaryCategory: string | null = null,
    componentType: ComponentType | null = 'Section',
): void {
    useEffect(() => {
        if (!isVisible) return;

        const components = getComponentArray();
        const alreadyTracked = components.some(c => c.componentInfo.componentID === componentID);

        if (!alreadyTracked) {
            components.push({
                componentInfo: { componentID },
                category: { primaryCategory, componentType },
            });
        }

        return () => {
            const data = digitalData();
            if (data?.component) {
                data.component = (data.component as ComponentEntry[]).filter(
                    c => c.componentInfo.componentID !== componentID,
                );
            }
        };
    }, [isVisible, componentID, primaryCategory, componentType]);
}
